import React from "react";
import PropTypes from "prop-types";
import IconLockedHexagon from "@learningblocks/exp-constants/lib/Icons/locked_hex.js";
import HexagonSolid from "@learningblocks/exp-constants/lib/Icons/hexagon-solid.js";
import CorrectRelative from "@learningblocks/exp-constants/lib/Icons/correct-relative.js";
import style from "./style.module.scss";

/**
 * IndexNumber:
 *  - To display the Menu Number in Notebook/MenuList/Menu
 */
export function IndexNumber(props) {
  const getClassName = (sub = "") =>
    `${style[`block${sub}`]} ${props.className + sub}`;

  const getAdjustedNumber = (menu, propsNumber) => {
    // If menu is not provided or invalid, return the original number
    if (!menu || !Array.isArray(menu)) {
      return propsNumber;
    }
    // propsNumber is 1-based, so the current index is propsNumber - 1
    const currentIndex = propsNumber - 1;

    const hiddenBefore = menu
      .slice(0, currentIndex) // only items before the current one
      .filter((item) => item.visible === false).length;

    return propsNumber - hiddenBefore;
  };

  return (
    <div className={getClassName()} aria-hidden="true">
      <span className={getClassName("_icon")} aria-hidden={true}>
        {!props.locked ? (
          <HexagonSolid className={getClassName("_icon_locked")} />
        ) : (
          <IconLockedHexagon className={getClassName("_icon_locked")} />
        )}
      </span>
      {props.completed ? (
        <>
          <CorrectRelative
            className={getClassName("_visited")}
            aria-hidden={true}
          />
          <p className={style.hidden}>
            {getAdjustedNumber(props.menuList, props.number)}
          </p>
        </>
      ) : !props.locked ? (
        <p className={getClassName("_number")} aria-hidden={true}>
          {getAdjustedNumber(props.menuList, props.number)}
        </p>
      ) : null}
    </div>
  );
}

IndexNumber.propTypes = {
  /**
   * Index number
   */
  number: PropTypes.number,
  /**
   * Boolean set if Section visited
   */
  visited: PropTypes.bool,
  completed: PropTypes.bool,
  /**
   * List of menu items for calculating adjusted numbers
   */
  menuList: PropTypes.arrayOf(PropTypes.object),
};

IndexNumber.defaultProps = {
  number: undefined,
  visited: false,
  completed: false,
  menuList: [],
};
